<app-modal #modal>

  <span title>{{"modal.ribbon.title"|translate}}</span>ù

  @if (selectedRibbon()) {

  <div body class="bento">
    <app-ribbon-bento-view [ribbon]="selectedRibbon()!"
      (handleClick)="handleRibbonColorPreviewClick($event)"></app-ribbon-bento-view>
  </div>

  }

</app-modal>
